import { toastService } from "src/libraries/toast";
import { getFeaturesUseCase } from "./getFeaturesUseCase";
import { CreateFeaturesDto } from "../entity/features/dto/create-features-dto";
import { featuresService } from "../entity/features/FeaturesService";

export const createFeaturesUseCase = async (body: CreateFeaturesDto) => {
    try {
        const formData = new FormData();
        Object.keys(body).forEach(key => {
            if (key === 'image' && body?.image) {
                formData.append('image', body.image, body.image.name)
            } else if (body[key] !== null && body[key] !== undefined) {
                formData.append(key, body[key].toString());
            }
        });
        const response = await featuresService.create(formData);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getFeaturesUseCase();
        }
        return response;
    } catch (error) {
        console.warn('createFeaturesUseCase: ', error);
    }
}  